import React from 'react';
import { CssBaseline } from '@mui/material';
import AppRouter from './router/AppRouter';
import { AuthProvider } from './context/AuthContext';
import './styles.css';
import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import esLocale from 'date-fns/locale/es'; // Para español opcionalmente

function App() {
  return (
    <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={esLocale}>
    <AuthProvider>
      <CssBaseline />
      <AppRouter />
    </AuthProvider>
    </LocalizationProvider>
  );
}

export default App;